// removed by extract-text-webpack-plugin
module.exports = {"settings":"_1ByyppbJI4eDOoxMzWDnsX"};


//////////////////
// WEBPACK FOOTER
// ./js/Components/LevelSettings.less
// module id = 532
// module chunks = 0